import { Controller } from "@hotwired/stimulus";
import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { StaticCategoriesSelect } from '../components/categories/StaticCategoriesSelect';

export default class extends Controller {
    connect() {
        const categories = JSON.parse(this.element.dataset.categories || '[]');
        const required = this.element.dataset.required === 'true';
        const form = this.element.closest('form');

        const handleChange = (selected) => {
            form.querySelectorAll('input[name="category_ids[]"]').forEach(el => el.remove());
            (selected || []).forEach(cat => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'category_ids[]';
                input.value = cat.value;
                form.appendChild(input);
            });
        };

        const SelectWrapper = () => {
            const [value, setValue] = useState([]);
            const [menuIsOpen, setMenuIsOpen] = useState(false);
            return (
                <StaticCategoriesSelect
                    options={categories}
                    value={value}
                    onChange={(selected) => {
                        setValue(selected || []);
                        handleChange(selected);
                        setMenuIsOpen(true);
                    }}
                    onMenuOpen={() => setMenuIsOpen(true)}
                    onMenuClose={() => setMenuIsOpen(false)}
                    menuIsOpen={menuIsOpen}
                    isSearchable={false}
                    placeholder="Select categories"
                    closeMenuOnSelect={false}
                />
            );
        };

        this.root = createRoot(this.element);
        this.root.render(<SelectWrapper />);
    }

    disconnect() {
        this.root?.unmount();
    }
}